import { useState, useEffect } from "react";

const SlideOver = () => {
    const [open, setOpen] = useState(true);

    // Close panel on 'Escape' key press
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") {
                setOpen(false);
            }
        };

        window.addEventListener("keydown", handleEscape);
        return () => {
            window.removeEventListener("keydown", handleEscape);
        };
    }, []);

    // Automatically reopen after 1 second when closed
    useEffect(() => {
        if (!open) {
            const timeout = setTimeout(() => setOpen(true), 1000);
            return () => clearTimeout(timeout);
        }
    }, [open]);

    return (
        <div className="border rounded-md relative">
            <div className="relative min-h-[500px] bg-gray-100">
                {open && (
                    <>
                        {/* Background overlay */}
                        <div
                            className={`absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-500 ${open ? "opacity-100" : "opacity-0"}`}
                            aria-hidden="true"
                        ></div>

                        <div className="absolute inset-y-0 right-0 flex max-w-full h-full">
                            {/* Slide-over panel */}
                            <div
                                className={`relative w-screen max-w-md transform transition-all duration-500 sm:duration-700 ${open ? "translate-x-0" : "translate-x-full"}`}
                            >
                                {/* Panel content */}
                                <div className="flex h-full flex-col overflow-y-scroll custom_scroll bg-white py-6 shadow-xl">
                                    <div className="px-4 sm:px-6">
                                        <h2 className="text-base font-semibold leading-6 text-gray-900" id="slide-over-title">
                                            Panel title
                                        </h2>
                                        {/* Close button */}
                                        <div className="absolute right-5 top-0 -ml-8 flex pr-2 pt-4 sm:-ml-10 sm:pr-4">
                                            <button
                                                type="button"
                                                className="rounded-md text-gray-300 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-white"
                                                onClick={() => setOpen(false)}
                                            >
                                                <span className="sr-only">Close panel</span>
                                                <svg
                                                    className="h-6 w-6"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M6 18L18 6M6 6l12 12"
                                                    />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                        {/* Placeholder content */}
                                        <div className="absolute inset-0 px-4 sm:px-6">
                                            <div className="relative h-full overflow-hidden rounded-xl border border-dashed border-gray-400 opacity-75">
                                                <svg className="absolute inset-0 h-full w-full stroke-gray-900/10" fill="none">
                                                    <defs>
                                                        <pattern
                                                            id="pattern-510798f3-74a4-4150-a0cf-4e93e8f4fbdf"
                                                            x="0"
                                                            y="0"
                                                            width="10"
                                                            height="10"
                                                            patternUnits="userSpaceOnUse"
                                                        >
                                                            <path d="M-3 13 15-5M-5 5l18-18M-1 21 17 3"></path>
                                                        </pattern>
                                                    </defs>
                                                    <rect stroke="none" fill="url(#pattern-510798f3-74a4-4150-a0cf-4e93e8f4fbdf)" width="100%" height="100%"></rect>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SlideOver;
